export function printDoc(el, { mode = "a4", draft = false, title = "Print" } = {}) {
  const els = (Array.isArray(el) ? el : [el]).filter(Boolean);
  if (els.length === 0) {
    window.print();
    return;
  }
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  iframe.setAttribute("data-testid", "print-frame");
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  const styles = [...document.querySelectorAll('link[rel="stylesheet"], style')]
    .map((n) => n.outerHTML)
    .join("\n");
  const css = `
    @page { size: ${mode === "thermal" ? "80mm auto" : "A4"}; margin: ${mode === "thermal" ? "4mm" : "12mm"}; }
    html, body { background: #fff; margin: 0; padding: 0; }
    body { ${mode === "thermal" ? "width: 72mm; font-family: 'Courier New', monospace; font-size: 10px;" : ""} }
    ${mode === "thermal" ? "table { font-size: 9px; } h2 { font-size: 13px !important; margin: 6px 0 !important; } img { max-height: 32px; }" : ""}
    .draft-watermark { position: fixed; top: 42%; left: 50%; transform: translate(-50%, -50%) rotate(-30deg);
      font-size: 90px; font-weight: 800; color: rgba(190, 30, 30, 0.14); letter-spacing: 8px;
      pointer-events: none; z-index: 60; font-family: Arial, sans-serif; }
  `;
  doc.open();
  doc.write(
    `<!DOCTYPE html><html><head><title>${title}</title>${styles}<style>${css}</style></head>` +
    `<body>${draft ? '<div class="draft-watermark">DRAFT</div>' : ""}${els.map((e) => e.outerHTML).join('<div style="page-break-after: always;"></div>')}</body></html>`
  );
  doc.close();
  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    setTimeout(() => iframe.remove(), 60000);
  }, 500);
}
